import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { AppEventsStore } from "@faire/retailer-visitor-shared/packages/core/services/AppEventsStore";
export var AppEvent = function AppEvent(eventName) {
    "use strict";
    var _this = this;
    _class_call_check(this, AppEvent);
    this.eventName = eventName;
    this.subscribe = function(listener) {
        AppEventsStore.get().appEvents.on(_this.eventName, listener);
    };
    this.unsubscribe = function(listener) {
        AppEventsStore.get().appEvents.off(_this.eventName, listener);
        AppEventsStore.get().appEvents.removeListener(_this.eventName, listener);
    };
    this.publish = function(data) {
        AppEventsStore.get().appEvents.emit(_this.eventName, data);
    };
    // Useful for testing
    this.unsubscribeAll = function() {
        AppEventsStore.get().appEvents.removeAllListeners();
    };
    if (AppEvent.appEventNames.has(eventName)) {
        throw new Error("The ".concat(eventName, " event already exists"));
    }
    AppEvent.appEventNames.add(eventName);
};
AppEvent.appEventNames = new Set();
